/* eslint-disable no-useless-escape */

// RegExpEmailInput
const VALID_EMAIL_REGEX = /([a-zA-Z0-9_\.\-])+(\+)?([a-zA-Z0-9_\.\-])*\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,})+\.?/;

// RegExpPostalCodeFormattedUsaOrCanada
const VALID_ZIP_REGEX = /(?:\d{5}(?:-\d{4})?)|(?:[A-Z]\d[A-Z] \d[A-Z]\d)/;

const FIRST_WORD_REGEX = /^([\w\-]+)/g;

// Remove extra spaces from the text
const REMOVE_EXTRA_SPACES_REGEX = /\ +/g;

const SPONSORSHIP_PO_NUMBER_REGEX = /\b2D-\d{8}\b/i;

const REQUISITION_ID_REGEX = /^JOB-US-(\d{10})$/;

const PATHNAME_REGEX = /\/\[[a-zA-Z]+\]/g;

// Must always be synced with backend
const SITE_ID_REGEX = /^(([A-Z0-9]{4,6}){1}(-[A-Z0-9_]{1,6})?)$/;

const MARKDOWN_LINK_WITHOUT_PROTOCOL = /\[(.+(\n.+)*?)\]\((?!https?:\/\/)(?:http:\/\/)?([^)\s]+)\)/g;

// LUT-532: À-ɏ adds Latin-1 Supplement + Latin Extended A/B letters
// (Zürich, Straße, São, Łódź, ...) so international org names/addresses validate.
// Additive only - everything previously accepted is still accepted.
const PRINTABLE_CHARACTERS = 'a-zA-Z0-9À-ɏ!"#$%&\'()*+,-./:;<=>?@[\\]^_`—•{|}~–™®\ufeffé\\s';
const PRINTABLE_CHARACTERS_MARKDOWN = `${PRINTABLE_CHARACTERS}\\\\\n\\t\\r’`;

const getPrintableCharactersRegex = (shouldValidateMarkdown = false) => (
  new RegExp(`^[${shouldValidateMarkdown ? PRINTABLE_CHARACTERS_MARKDOWN : PRINTABLE_CHARACTERS}]*$`, 'i')
);

const getInvalidCharactersRegex = (shouldValidateMarkdown = false) => (
  new RegExp(`[^${shouldValidateMarkdown ? PRINTABLE_CHARACTERS_MARKDOWN : PRINTABLE_CHARACTERS}]+`, 'gi')
);

const FLOAT_VALUES_REGEX = /^([0-9]*(\.[0-9]*)?|\.[0-9]*)$/;

export {
  VALID_EMAIL_REGEX,
  VALID_ZIP_REGEX,
  FIRST_WORD_REGEX,
  REMOVE_EXTRA_SPACES_REGEX,
  SPONSORSHIP_PO_NUMBER_REGEX,
  REQUISITION_ID_REGEX,
  SITE_ID_REGEX,
  PATHNAME_REGEX,
  MARKDOWN_LINK_WITHOUT_PROTOCOL,
  getPrintableCharactersRegex,
  getInvalidCharactersRegex,
  FLOAT_VALUES_REGEX,
};

export default {
  VALID_EMAIL_REGEX,
  VALID_ZIP_REGEX,
  FIRST_WORD_REGEX,
  REMOVE_EXTRA_SPACES_REGEX,
  SPONSORSHIP_PO_NUMBER_REGEX,
  REQUISITION_ID_REGEX,
  SITE_ID_REGEX,
  PATHNAME_REGEX,
  MARKDOWN_LINK_WITHOUT_PROTOCOL,
  getPrintableCharactersRegex,
  getInvalidCharactersRegex,
  FLOAT_VALUES_REGEX,
};
